export const OPEN_VOLUME_PRICING_MODAL = 'open-volume-pricing-modal'
